import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { TilintarkastajaKirjautumistapa, TilintarkastajaLoginInformation } from 'app/_jaettu-lemonator/model/tilintarkastaja'

@Component({
  templateUrl: './tilintarkastaja.login-history.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TilintarkastajaLoginHistoryDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TilintarkastajaLoginInformation[],
    private _dialogRef: MatDialogRef<TilintarkastajaLoginHistoryDialog>,
  ) {}

  annaKirjautumistapaText(tapa: TilintarkastajaKirjautumistapa): string {
    if (tapa === 'tilintarkastaja-tunnistautuminen') {
      return 'Tunnistautuminen'
    }
    if (tapa === 'tilintarkastaja-kirjautuminen') {
      return 'Kirjautuminen'
    }
    if (tapa === 'superuser') {
      return 'Superuser'
    }
    return tapa
  }

  sulje() {
    this._dialogRef.close()
  }
}
